module.exports = __webpack_public_path__ + "img/te-mision3.0800072c.jpg";